var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full w-full bg-primary-500 relative"},[_c('WavesBackgroundCanvas',{staticClass:"absolute"}),_vm._v(" "),_c('div',{staticClass:"relative overflow-auto h-full py-12"},[_c('nuxt')],1),_vm._v(" "),_c('NotificationFooterOverlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }